export const common = {
  siteName: '韩漫之家',
  siteTagline: '专业韩漫在线阅读平台',
  nav: {
    home: '首页',
    categories: '分类',
    popular: '热门',
    latest: '最新',
    about: '关于我们',
    search: '搜索漫画...',
  },
  footer: {
    copyright: '© 2026 韩漫之家 版权所有',
    privacy: '隐私政策',
    terms: '服务条款',
    contact: '联系我们',
    subscribe: '订阅更新',
    subscribeDesc: '第一时间获取最新韩漫更新资讯',
    emailPlaceholder: '输入您的邮箱',
    subscribeBtn: '订阅',
  },
  breadcrumb: {
    home: '首页',
  },
  cta: {
    startReading: '开始阅读',
    viewAll: '查看全部',
    readNow: '立即阅读',
    loadMore: '加载更多',
  },
  stats: {
    totalComics: '漫画总数',
    totalChapters: '章节数量',
    activeReaders: '活跃读者',
    dailyUpdates: '每日更新',
  },
  seo: {
    homeTitle: '韩漫之家_韩漫在线观看_免费漫画下拉式阅读平台',
    homeDesc: '韩漫之家作为专业的韩漫网站，专注于免费下拉式漫画在线观看，采用智能加载技术，确保阅读体验流畅舒适。海量热门韩漫、最新更新、分类齐全，尽在韩漫之家。',
    homeKeywords: '韩漫网站,韩漫在线观看,免费漫画,下拉式,韩漫之家,智能加载,阅读体验,韩漫',
    categoryTitle: '{{category}}_韩漫分类_韩漫之家',
    categoryDesc: '韩漫之家{{category}}分类，汇聚海量精品韩漫，免费下拉式阅读，智能加载流畅体验。',
    comicTitle: '{{title}}_韩漫在线观看_韩漫之家',
    comicDesc: '韩漫之家提供{{title}}免费下拉式在线阅读，智能加载技术，流畅舒适的阅读体验。',
    aboutTitle: '关于我们_韩漫之家_专业韩漫在线阅读平台',
    aboutDesc: '了解韩漫之家品牌故事、用户口碑与联系方式。作为专业韩漫网站，我们致力于为用户提供优质的免费下拉式漫画阅读体验。',
  },
};